import Instance from "../../../../Axios";

// New Actions for the app

const GetCredViaturaUploadedFiles = (credId) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/credenciacao/${credId}/files`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_VIATURA_UPLOADED_FILES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredViaturaUploadedFiles;